import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';
import { QuestionOpinion } from 'model/QuestionOpinion';

import { DepartmentDto } from './dto/Department.dto';

export namespace TrendItemsApi {
  export type Entry = QuestionOpinion[];
}

export class TrendItemsApi {
  constructor(private client: AxiosInstance) {}

  list(id: number): Promise<TrendItemsApi.Entry> {
    return this.client
      .get<WithData<TrendItemsApi.Entry>>(`/api/v1/project/${id}/trend-items`)
      .then(selectApiData);
  }

  setConnectedDepartments(sourceId: number, destinationId: number): Promise<DepartmentDto> {
    return this.client
      .post(`/api/v1/department/update-connection/${sourceId}/${destinationId}`)
      .then((response) => response.data.data);
  }
}
